import e from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import h from "./iconfont.es5471.js";
const i = {
  display: "block"
}, x = ({ size: t = 16, useVw: c, useRem: l, color: o, withColor: a, removeClassName: f, disableSSR: d, style: n, ...m }) => {
  const p = n ? { ...i, ...n } : i;
  return /* @__PURE__ */ e.createElement(h, { disableSSR: d }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "facebook-24px", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: c ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (l ? "rem" : "px"), height: c ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (l ? "rem" : "px"), className: f ? "" : "iconpark-icon", style: p, fill: "none", ...m }, /* @__PURE__ */ e.createElement(
    "g",
    {
      clipPath: "url(#1258e5__a)"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fill: a ? r(o, 0, "currentColor") : "currentColor",
        datafollowfill: a ? r(o, 0, "currentColor") : "currentColor",
        d: "M23.624 12C23.624 5.578 18.42.375 11.999.375S.374 5.578.374 12c0 5.802 4.25 10.612 9.808 11.484V15.36H7.23V12h2.953V9.439c0-2.914 1.735-4.523 4.391-4.523 1.272 0 2.603.227 2.603.227v2.86H15.71c-1.443 0-1.894.896-1.894 1.815V12h3.224l-.515 3.36h-2.709v8.124c5.558-.872 9.809-5.682 9.809-11.484Z"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "defs",
    null
  ), /* @__PURE__ */ e.createElement(
    "clipPath",
    {
      id: "1258e5__a"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fill: a ? r(o, 1, "#fff") : "#fff",
        d: "M0 0h24v24H0z"
      }
    )
  )));
}, s = x;
export {
  s as default
};
